import React from 'react';

const Portfolio = () => {
  const capabilities = [
    { title: 'E-commerce Experiences', category: 'Conversion Focused', color: '#2bd5c4', icon: '🛍️', desc: 'Custom stores and funnels designed to turn visitors into loyal customers.' },
    { title: 'SaaS & Web Applications', category: 'User-Centric', color: '#f4ba40', icon: '💻', desc: 'Intuitive, modern interfaces that make complex software feel effortless.' },
    { title: 'Distinct Brand Identities', category: 'Visual Strategy', color: '#ff69b4', icon: '✨', desc: 'Memorable logos and design systems that help you stand out in the market.' },
    { title: 'High-Impact Campaigns', category: 'Content & Media', color: '#4285F4', icon: '🚀', desc: 'Scroll-stopping video and graphic assets for paid ads and organic social.' },
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="container">
        <div className="section-header" style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
            <div style={{ flex: '1', minWidth: '300px' }}>
              <h2 className="section-title">What We Can <span className="text-gradient-teal-gold">Build For You</span></h2>
              <p className="section-subtitle" style={{ margin: '0', textAlign: 'left', maxWidth: '600px' }}>
                We don't rely on past laurels; we focus entirely on your future. Here are the core digital experiences we are ready to create for your brand.
              </p>
            </div>
            <a href="#cta"><button className="btn-secondary">Let's Brainstorm</button></a>
          </div>
          
          {/* New Agency Banner */}
          <div style={{ background: 'rgba(43, 213, 196, 0.08)', border: '1px solid rgba(43, 213, 196, 0.2)', padding: '20px 24px', borderRadius: '16px', display: 'flex', alignItems: 'center', gap: '20px', width: '100%', marginTop: '10px' }}>
            <div style={{ fontSize: '32px' }}>🤝</div>
            <div>
              <div style={{ fontWeight: '700', color: 'var(--primary-teal)', fontSize: '18px', marginBottom: '6px' }}>Early Partner Advantage</div>
              <div style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.5' }}>As a fast-growing new agency, we are highly selective with our initial projects. Partner with us now to receive dedicated, founder-level attention and priority execution on your project.</div>
            </div>
          </div>
        </div>

        <div className="portfolio-grid">
          {capabilities.map((item, index) => (
            <div key={index} className="portfolio-card" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="portfolio-image" style={{ background: `linear-gradient(135deg, rgba(20,25,30,1) 0%, ${item.color}22 100%)`, borderBottom: '1px solid rgba(255,255,255,0.05)', height: '220px' }}>
                 <div style={{ width: '80px', height: '80px', background: 'rgba(255,255,255,0.03)', borderRadius: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '40px', border: `1px solid ${item.color}44`, boxShadow: `0 10px 40px ${item.color}33`, transition: 'transform 0.3s ease' }} className="capability-icon">
                   {item.icon}
                 </div>
              </div>
              <div className="portfolio-info" style={{ padding: '32px 24px', flex: '1', display: 'flex', flexDirection: 'column' }}>
                <div className="portfolio-category" style={{ color: item.color }}>{item.category}</div>
                <h3 className="portfolio-title" style={{ marginBottom: '16px', fontSize: '22px' }}>{item.title}</h3>
                <p style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
